<template>
  <section>
    <h3 class="closing-page__header">You are all set!</h3>
    <p>Your account now contains datapoints ready to be annotated. You can already aggregate them in your python notebook.</p>
    <p>
      Open the <a href="http://annotator.saliency.ai/" target="_blank">annotation tool</a> to start annotating.
    </p>
    <p>
      Open our <a href="https://colab.research.google.com/drive/1qTcG-pRgX58lLQEISz-swgirluLnRTam" target="_blank">Colab Notebook</a> and clone it to start exploring the data.
    </p>
    <p>
      This page is the console which allows you are in the console which allows you to brows the data and define annotation tasks.
    </p>
  </section>
</template>
<script>
  export default {
    name: 'page-one'
  }
</script>
<style lang="scss" scoped>
.closing-page {
  &__header {
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
</style>
